<template>
  <base-layout>
    <v-row>
      <v-col
        cols="12"
        md="6">
        <v-row>
          <v-col
            cols="12"
            class="pt-0"
            md="9">
            <vue-tel-input
              v-model="phone"
              :preferred-countries="preferredCountries"
              @onEnter="telInfo.isValid ? findMember() : () => {}"
              @onInput="validateTel" />
          </v-col>
          <v-col
            cols="12"
            class="pt-0"
            md="3">
            <v-btn
              :disabled="!telInfo.isValid"
              outlined
              width="100%"
              color="primary"
              @click="findMember">
              Find
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <FormEdit
            v-if="isFetchMember"
            :member="member"
            :is-new-member="isNewMember"
            @onUpdateMember="updateMember"
            @onCreateMember="createMember" />
        </v-row>
      </v-col>
      <v-col
        cols="12"
        md="6"
        class="pt-0">
        <calculator
          v-if="isFetchMember"
          :number="spending"
          :is-new-member="isNewMember"
          @on-update="(val) => { spending = val }"
          @OnConfirmCalculate="() => { activeConfirmModal = true }" />
      </v-col>
    </v-row>
    <ConfirmAddSpendingModal
      :active="activeConfirmModal"
      :spending="spending"
      :member="member"
      @onClose="() => { activeConfirmModal = false }"
      @onConfirm="confirmAddSpending" />
  </base-layout>
</template>

<script>
import { mapActions } from 'vuex'
import MemberProvider from '@/resources/MemberProvider'
import SmsProvider from '@/resources/SmsProvider'
import dayjs from 'dayjs'
import Calculator from '../components/Calculator.vue'
import FormEdit from '../components/FormEdit.vue'
import ConfirmAddSpendingModal from '../components/ConfirmAddSpendingModal.vue'

const smsService = new SmsProvider()
const memberService = new MemberProvider()
export default {
  components: {
    Calculator,
    FormEdit,
    ConfirmAddSpendingModal
  },
  data () {
    return {
      phone: '',
      telInfo: {},
      prefixSms: 'ยินดีด้วยค่ะ คุณได้รับส่วนลด 100 บาท  สามารถรับส่วนลดได้ที่',
      member: {},
      isFetchMember: false,
      isNewMember: false,
      activeConfirmModal: false,
      spending: '0',
      preferredCountries: ['TH', 'SG', 'MY', 'CN']
    }
  },
  methods: {
    ...mapActions({
      setLoading: 'Style/setLoading',
      setSnackbar: 'Style/setSnackbar',
      setModal: 'Style/setModal'
    }),
    sendSmsNgamwongwan (tel) {
      const now = dayjs().format('YYMMDD')
      // +66972789445
      const subTel = tel.substr(tel.length - 4, tel.length - 1)
      const key = parseInt(`${now}${subTel}`, 0).toString(16)
      const link = process.env.VUE_APP_MEMBER_LINK
      smsService.single(
        tel,
        `${this.prefixSms} ${link}/ngamwongwan?ref=${key.toLowerCase()}`
      )
    },
    async confirmAddSpending (payload) {
      await this.setLoading({
        active: true,
        clickAble: false,
        message: 'Updating.'
      })
      try {
        this.activeConfirmModal = false
        await memberService.addMemberSpending(payload)
        // ngamwongwan send sms
        // if (payload.reference === 'Ngamwongwan') {
        //   this.sendSmsNgamwongwan(payload.tel)
        // }
        this.setSnackbar({
          message: 'Success',
          type: 'success',
          timeout: 3000,
          canClose: true,
          value: true
        })
        this.spending = '0'
        this.findMember()
      } catch (err) {
        this.setSnackbar({
          message: err.message,
          type: 'pink',
          timeout: 3000,
          canClose: true,
          value: true
        })
      } finally {
        await this.setLoading({
          active: false,
          clickAble: false,
          message: 'Getting member.'
        })
      }
    },
    async findMember () {
      await this.setLoading({
        active: true,
        clickAble: false,
        message: 'Getting member.'
      })
      this.isNewMember = false
      this.isFetchMember = false
      try {
        const { data } = await memberService.getMemberByTel(this.telInfo.tel)
        if (data !== null) {
          this.member = data
        } else {
          this.isNewMember = true
          this.member = {
            createdIn: 'manual_storefront',
            tel: this.telInfo.tel,
            telInfo: this.telInfo.telInfo,
            firstName: '',
            type: 'normal',
            lastName: '',
            cardId: '',
            email: '',
            birthDate: null,
            spending: {
              total: 0,
              vip: 0,
              vvip: 0
            },
            gender: 'N/A',
            note: ''
          }
        }
        this.isFetchMember = true
      } catch (err) {
        this.setSnackbar({
          message: err.message,
          type: 'pink',
          timeout: 3000,
          canClose: true,
          value: true
        })
      } finally {
        await this.setLoading({
          active: false,
          clickAble: false,
          message: 'Getting member.'
        })
      }
    },
    async updateMember (member) {
      await this.setLoading({
        active: true,
        clickAble: false,
        message: 'Updating member.'
      })
      try {
        await memberService.updateMember(this.member.id, member)
        this.setSnackbar({
          message: 'Success',
          type: 'success',
          timeout: 3000,
          canClose: true,
          value: true
        })
        this.telInfo.tel = member.tel
        this.telInfo.telInfo = member.telInfo
        this.phone = member.tel
        this.findMember()
      } catch (err) {
        this.setSnackbar({
          message: err.message,
          type: 'pink',
          timeout: 3000,
          canClose: true,
          value: true
        })
      } finally {
        await this.setLoading({
          active: false,
          clickAble: false,
          message: 'Getting member.'
        })
      }
    },
    async createMember (member) {
      await this.setLoading({
        active: true,
        clickAble: false,
        message: 'Updating member.'
      })
      try {
        await memberService.createMember(member)
        this.setSnackbar({
          message: 'Success',
          type: 'success',
          timeout: 3000,
          canClose: true,
          value: true
        })
        await this.findMember()
      } catch (err) {
        this.setSnackbar({
          message: err.message,
          type: 'pink',
          timeout: 3000,
          canClose: true,
          value: true
        })
      } finally {
        await this.setLoading({
          active: false,
          clickAble: false,
          message: 'Getting member.'
        })
      }
    },
    validateTel ({ number, isValid, country }) {
      this.telInfo = {
        tel: number.e164,
        isValid,
        telInfo: {
          dialCode: country.dialCode,
          iso2: country.iso2,
          name: country.name
        }
      }
    }
  }
}
</script>
<style scoped>
.fade-in {
  transition:opacity 0.8s
}
</style>
